  
import uploadFile from './direct_upload'
import base64ToFile from './base64_to_file'
import directUploadFile from './direct_upload_file'
import transform_one_file_to_signed_id from './transform_one_file_to_direct_upload'

async function transform_files_to_direct_upload(photo_compressed){
  let pc_signeds = []
  try {
    let pc = []
    if (Array.isArray(photo_compressed)){
      pc = photo_compressed.filter(p=> !pc.id && pc.data)
    } else {
      pc = [photo_compressed]
    }
    for (let idx = 0; idx < pc.length; idx++) {
      const element = pc[idx];

      let sign = await directUploadFile(element)
      // console.log({sign});
      pc_signeds.push(sign)

      // console.log(element)
      // let blob = await base64ToFile(element)

      // blob = await uploadFile(blob)

      // pc_signeds.push(blob.signed_id)
    }
    return pc_signeds
  } catch (error) {
    console.log({error});
    throw error
  }
}

export default transform_files_to_direct_upload